import { FC } from "react"
import SearchSvg from '@/shared/assets/images/MagnifyingGlass.svg'

interface SearchProps {
    onChange: (arg0: string) => void
    value: string
}

export const Search: FC<SearchProps> = ({ onChange, value }) => {
    return (
        <div className="w-full relative items-center h-[52px] overflow-hidden rounded-full">
            <input 
                type="text"
                value={value ?? ''}
                onChange={(e) => onChange(e.target.value)}
                className="w-full [&:focus]:outline-0 outline-none text-color-dark text-[14px] pl-10 [&::placeholder]:text-color-dark border-0 h-full"
                placeholder="Поиск"
            />
            <div className="absolute top-0 bottom-0 h-full flex items-center ml-4">
                <SearchSvg width={20} height={20} />
            </div>
        </div>
    )
}